import "./CardSections.css";
import { useState, useEffect } from "react";

const IRC5ABBIrb1600 = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);
  const textOnCard = (
    <div className="text-in-card">
      <h3>Що входить в систему:</h3>
      <hr />
      <ul>
        <li>1) Робот-маніпулятор ABB IRB 1600 з контролером IRC5</li>
        <li>2) Позиціонер (обертач, 2 осі), синхронізований із роботом</li>
        <li>
          3) Зварювальний апарат Fronius TPS 4000 + роботизована подача
          зварювального дроту
        </li>
        <li>4) Роботизований рукав із рідинною системою охолодження</li>
        <li>5) Навчання оператора/персоналу</li>
      </ul>
      <p className="weight-text">Ціна системи: 38 000 євро</p>
    </div>
  );
  return (
    <div className="card-blok">
      <h2>ABB IRB 1600 з контролером IRC5</h2>
      <div className="card">
        <div className="card-img">
          <img
            src={require("../../../STATIC/images/OrangeRobots/WhiteURobot.webp")}
            alt="Robot"
          />
        </div>
        <div className="card-video-text">
          <iframe
            src="https://www.youtube.com/embed/fHZI1CzQqt0"
            title="ABB Robotics - New Generation Workpiece Positioners"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
          {windowWidth > 900 ? textOnCard : ""}
        </div>
        {windowWidth <= 900 ? textOnCard : ""}
      </div>
    </div>
  );
};

export default IRC5ABBIrb1600;
